import { UpdateDraftParams } from 'app/dataTypes/cafeteria/compensation/withdraw/toParent/draft'

import type { Request } from '../../../../index'


type ParamsApi = {
  withdraw_order_id: number
  data: {
    bik: string
    checking_account: string
    parent_phone: string
    parent_address: string
  },
  value: number
}

export const convertParams = ({
  withdrawID,
  bik,
  checkingAccount,
  parentPhone,
  parentAddress,
  value,
}: UpdateDraftParams): [ParamsApi, null] => {
  return [{
    withdraw_order_id: parseInt(withdrawID, 10),
    data: {
      bik,
      checking_account: checkingAccount,
      parent_phone: parentPhone,
      parent_address: parentAddress,
    },
    value,
  }, null]
}

export const convertResult = (res: 'success'): boolean => {
  return !!res
}

export const POST_COMPENSATION_WITHDRAW_ORDERS_UPDATE_DRAFT: Request<UpdateDraftParams, boolean, void> = [
  'cabinet/compensation/withdraw_orders/update_draft',
  'post',
  ['data', 'result'],
]
